module.exports = __webpack_public_path__ + "static/media/sweet_3.c84b82ed.png";